import { UserCheck, ShieldCheck, Award, Globe } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { STATS } from "../data/site";

const POINTS = [
    { icon: UserCheck, title: "Personalized Analysis", text: "Every reading is handcrafted — never templated, never generic." },
    { icon: Award, title: "Experienced Consultant", text: "8+ years, 3,500+ healings, 350+ students and a PhD in progress." },
    { icon: ShieldCheck, title: "Confidential & Private", text: "Your details, handwriting and story stay strictly between us." },
    { icon: Globe, title: "Online & In-Person", text: "Consult from anywhere in the world, or visit us in Mulund West." },
];

export const WhyUs = () => {
    return (
        <section data-testid="why-us-section" className="py-28 lg:py-36 px-6 bg-[#0B1730] border-y border-white/5">
            <div className="max-w-7xl mx-auto">
                <Reveal className="max-w-2xl">
                    <Overline>Why Ink of Destiny</Overline>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#F0EBE0]">
                        Trust written in <span className="italic text-[#C9A962]">ink</span>
                    </h2>
                </Reveal>

                <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6">
                    {STATS.map((s, i) => (
                        <Reveal key={s.label} delay={i * 0.1}>
                            <div data-testid={`stat-${i}`} className="text-center md:text-left border-l border-[#C9A962]/20 pl-5 py-2">
                                <p className="font-mono-num text-4xl lg:text-5xl font-light text-[#C9A962] text-glow-gold">{s.value}</p>
                                <p className="mt-2 text-xs uppercase tracking-[0.2em] text-[#A19D94]">{s.label}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {POINTS.map(({ icon: Icon, title, text }, i) => (
                        <Reveal key={title} delay={i * 0.1}>
                            <div className="rounded-2xl border border-white/10 bg-[#0E1B33] p-7 h-full hover:border-[#C9A962]/30 hover:-translate-y-1 transition-all duration-500">
                                <Icon size={22} className="text-[#C9A962] mb-5" />
                                <h3 className="font-display text-lg font-semibold text-[#F0EBE0]">{title}</h3>
                                <p className="mt-2 text-sm font-light text-[#A19D94] leading-relaxed">{text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
